import React, { useEffect, useState } from "react";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import TableAHSF from "../../../../Components/TableAHSF";
import AddEditeSubSectorsPage from "./AddEditeSubSectorsPage";
import PopupAHSF from "../../../../Components/PopupAHSF";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Account/EncryptionParams";

const OtherMainSubSectorsTable = () => {
  const AppGuid = useParams();
  //console.log(AppGuid, "sdsdwwwwsdsd");

  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [SecondarySectorsId, setSecondarySectorsId] = useState(null);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const RequestAccessor = [
    {
      KeyName: "aI_MainSectorAr",
      ShowStatus: true,
      NmaeColumn: "القطاعات الثانوية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        setSecondarySectorsId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },

    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action:
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/AI_SecondarySectors/DeleteAI_SecondarySectors",
              {
                aI_SecondarySectorsId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //to refresh table
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataAddStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <AddEditeSubSectorsPage />
      </div>
    ),

    title: "القطاعات الثانوية التي تمثل المشروع",
    maxWidth: "30%",
    maxHeight: "30%",
    idssss: "SecondarySectors",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },

    componentBody: (
      <div>
        <AddEditeSubSectorsPage
          SecondarySectorsId={SecondarySectorsId}
          BtnClick="edit"
        />
      </div>
    ),

    title: "القطاعات الثانوية التي تمثل المشروع",
    maxWidth: "30%",
    maxHeight: "30%",
    idssss: "SecondarySectors",
  };

  return state.ApplicationInformation && state.ActiveRound ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_SecondarySectorsId"}
        valueButtonAction={"aI_SecondarySectorsId"}
        URL={`api/AI_SecondarySectors/GetListAI_SecondarySectors`}
        UrlBody={{
          aI_ApplicationInformationId:
            localStorage.getItem("aI_ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"القطاعات الثانوية التي تمثل المشروع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  ) : (
    ""
  );
};

export default OtherMainSubSectorsTable;
